import { useContext } from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';

import AuthContext from '../../contexts/authContext';

import { ProtectedRoutes } from '../ProtectedRoutes';
import Users from '../users/Users';
import Collections from '../collections/Collections';
import CollectionsCreate from '../collections/CollectionsCreate';
import CollectionsEditForm from '../collections/CollectionsEditForm';
import Releases from '../releases/Releases';
import Domains from '../deploy/Domains';
import NotFound from '../not-found/NotFound';

import './App.module.scss';

import Notification from '../UI/notification/Notification';

const App = () => {
  const { availableFeatures } = useContext(AuthContext);

  const { areLocalDomainsAvailable } = availableFeatures;

  return (
    <>
      <Routes>
        <Route element={<ProtectedRoutes />}>
          <Route index path="/" element={<Navigate to="/users" />} />
          <Route path="/users" element={<Users />} />
          <Route path="/collections" element={<Collections />} />
          <Route path="/collections/create" element={<CollectionsCreate />} />
          <Route path="/collections/:id" element={<CollectionsEditForm />} />
          {areLocalDomainsAvailable ? (
            <Route path="/deploy" element={<Domains />} />
          ) : null}
          <Route path="/releases" element={<Releases />} />
          <Route path="*" element={<NotFound text="Страница не найдена" />} />
        </Route>
      </Routes>
      <Notification />
    </>
  );
};

export default App;
